import { sanitizeCpf, validateCpf, formatCpfDisplay } from './cpf';
import { sanitizeCnpj, validateCnpj, looksLikeCnpj, formatCnpjDisplay } from './cnpj';

export { validateCpf, sanitizeCpf, formatCpfDisplay } from './cpf';
export { validateCnpj, looksLikeCnpj, sanitizeCnpj, formatCnpjDisplay } from './cnpj';

export function normalizeBrazilianTaxId(value) {
  if (looksLikeCnpj(value)) {
    return sanitizeCnpj(value);
  }

  return sanitizeCpf(value);
}

export function validateCpfOrCnpj(value) {
  if (!value) {
    return false;
  }

  if (looksLikeCnpj(value)) {
    return validateCnpj(value);
  }

  return validateCpf(value);
}

export function formatDocumentDisplay(value) {
  if (looksLikeCnpj(value)) {
    return formatCnpjDisplay(value);
  }

  return formatCpfDisplay(value);
}

function getInputValue(event) {
  if (event && event.target) {
    return event.target.value;
  }

  return event;
}

export function countRawChars(value) {
  return String(value).replace(/[^0-9A-Za-z]/g, '').length;
}

export function caretPositionFromRawIndex(formattedValue, rawIndex) {
  if (rawIndex <= 0) {
    return 0;
  }

  let count = 0;
  for (let i = 0; i < formattedValue.length; i++) {
    if (/[0-9A-Za-z]/.test(formattedValue[i])) {
      count++;
      if (count >= rawIndex) {
        return i + 1;
      }
    }
  }

  return formattedValue.length;
}

function restoreCaretAfterFormat(input, rawIndex) {
  const applyCaret = () => {
    const position = caretPositionFromRawIndex(input.value, rawIndex);
    input.setSelectionRange(position, position);
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(applyCaret);
  });
}

function handleFormattedInput(event, assign, format) {
  const input = event && event.target;

  if (!input) {
    assign(format(getInputValue(event)));
    return;
  }

  const selectionStart = input.selectionStart != null ? input.selectionStart : input.value.length;
  const rawIndex = countRawChars(input.value.slice(0, selectionStart));
  const formatted = format(getInputValue(event));

  assign(formatted);
  restoreCaretAfterFormat(input, rawIndex);
}

export function onCnpjInput(event, assign) {
  handleFormattedInput(event, assign, formatCnpjDisplay);
}

export function onDocumentInput(event, assign) {
  handleFormattedInput(event, assign, formatDocumentDisplay);
}
